import { Component, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'ui2-toggle-switch',
  templateUrl: './ui2-toggle-switch.component.html',
  styleUrls: ['./ui2-toggle-switch.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => Ui2ToggleSwitchComponent),
      multi: true
    }
  ]
})
export class Ui2ToggleSwitchComponent implements ControlValueAccessor {
  public value: boolean;

  /*

  Implementing ngModel
  */

  public onChange: (value: boolean) => any = () => {};
  public onTouch: (value: boolean) => any = () => {};

  public set model(val: boolean) {
    if (val !== undefined && this.value !== val) {
      this.value = val;
    }
  }

  public writeValue(value: boolean) {
    this.model = value;
  }

  public registerOnChange(fn: (value: boolean) => any) {
    this.onChange = fn;
  }

  public registerOnTouched(fn: (value: boolean) => any) {
    this.onTouch = fn;
  }

  /*
    TOGGLE UI
    we want to only output ngModel change on user interaction not in data change
  */

  public switchChange() {
    this.value = !this.value;
    this.onChange(this.value);
    this.onTouch(this.value);
  }
}
